import axios from 'axios'

export default {
    getLogin(){
        return axios.get('/user')
            .then(response => {
                return response.data
            })
    },
    
    
}